/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Box, useMediaQuery } from "@mui/material";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ContactUs from "../../modules/contactUs/ContactUs";
import TestDrive from "../../modules/test-drive/TestDrive";
import TrainingVideo from "../../modules/training-video/TrainingVideo";
import DealerInfo from "../../modules/DealerInfo";
import HomePage from "../../modules/homePage/HomePage";
import ServiceGuide from "../../modules/service/ServiceGuide";
import Footer from "../components/footer/Footer";
import Header from "../components/header/Header";
import AboutUs from "../components/about-us/AboutUs";
import DealerSearchWrapper from "../components/dealer-search/DealerSearchWrapper";
import { DESKTOP_VIEW_WIDTH, TAB_VIEW_WIDTH } from "../constants/constants";
import NewsUpdate from "../../modules/newsUpdate/NewsUpdate";
import StickyLinks from "../components/stickyLinks/StickyLinks";
import PageNotFound from "../../modules/pageNotFound/PageNotFound";
import CarModel from "../../modules/carModel/CarModel";
import FinanceAndLeasing from "../../modules/financeAndLeasing/FinanceAndLeasing";
import SearchResultPage from "../components/header/searchResult/SearchResultPage";
import LiveStream from "../../modules/live-stream/LiveStream";
import EventAndCampaign from "../../modules/events-and-campaign/EventAndCampaign";
import LiveStreamDetail from "../../modules/live-stream/LiveStreamDetail";
import EventAndCampaignDetail from "../../modules/events-and-campaign/EventAndCampaignDetail";
import CarModelDetail from "../../modules/carModelDetail/CarModelDetail";
import NewsDetailPage from "../../modules/newsUpdate/newsDetailPage/NewsDetailPage";
import TrainingDetailPage from "../../modules/training-video/trainingDetailPage/TrainingDetailPage";
import CustomerService from "../../modules/customerService/CustomerService";
import CookiesPolicy from "../../modules/footerDetails/CookiesPolicy";
import PrivacyPolicy from "../../modules/footerDetails/PrivacyPolicy";
import Industry from "../../modules/industry/Industry";
import { EnvQuery } from "../../modules/envQuery/EnvQuery";
import IndustryDetailPage from "../../modules/industryDetailPage/IndustryDetailPage";
import PurchasedDetail from "../../modules/purchasedDetail/PurchasedDetail";
import ConnectedTruck from "../../modules/connectedTruck/ConnectedTruck";

const mainBody = (matches, matchesTab) => css`
  padding-top: ${(matches && "110px") || (matchesTab && "110px") || "64px"};
  background: #121212;
`;

const Routers = () => {
  const matches = useMediaQuery(DESKTOP_VIEW_WIDTH);
  const matchesTab = useMediaQuery(TAB_VIEW_WIDTH);
  const params = new URLSearchParams(window.location.search);
  const id = params.get("id");
  const type = params.get("type");
  const slug = params.get("slug");
  let draftPreviewComponent;
  switch (type) {
    case "dealer":
      draftPreviewComponent = <DealerInfo Id={id} />;
      break;
    case "contactus":
      draftPreviewComponent = <ContactUs />;
      break;
    case "aboutus":
      draftPreviewComponent = <AboutUs />;
      break;
    case "home":
      draftPreviewComponent = <HomePage />;
      break;
    case "serviceContractDetail":
      draftPreviewComponent = <ServiceGuide Slug={slug} />;
      break;
    case "newsDetail":
      draftPreviewComponent = <NewsDetailPage Slug={slug} />;
      break;
    case "trainingDetail":
      draftPreviewComponent = <TrainingDetailPage Slug={slug} />;
      break;
    case "truckModel":
      draftPreviewComponent = <CarModel Slug={slug} />;
      break;
    case "truckModelDetails":
      draftPreviewComponent = <CarModelDetail Slug={slug} />;
      break;
    case "eventsAndCampaignsDetails":
      draftPreviewComponent = <EventAndCampaignDetail Slug={slug} />;
      break;
    case "generalDetailPages":
      draftPreviewComponent = (
        <EventAndCampaignDetail Slug={slug} compName={"generalDetailPages"} />
      );
      break;
    case "liveStreamDetails":
      draftPreviewComponent = (
        <LiveStreamDetail compName={"liveStream"} Slug={slug} />
      );
      break;
    case "contactUs":
      draftPreviewComponent = <ContactUs />;
      break;
    case "customerService":
      draftPreviewComponent = <CustomerService />;
      break;
    case "eventsAndCampaigns":
      draftPreviewComponent = <EventAndCampaign />;
      break;
    case "liveStream":
      draftPreviewComponent = <LiveStream />;
      break;
    case "dealerSearch":
      draftPreviewComponent = <DealerSearchWrapper />;
      break;
    case "purchasedCar":
      draftPreviewComponent = <ConnectedTruck />;
      break;
    case "purchasedDetail":
      draftPreviewComponent = <PurchasedDetail />;
      break;
    default:
      draftPreviewComponent = <PageNotFound />;
      break;
  }

  return (
    <BrowserRouter basename="trucks">
      <Header />
      <Box css={() => mainBody(matches, matchesTab)}>
        <StickyLinks />
        <Routes>
          <Route exact path="/contact-us" element={<ContactUs />} />
          <Route exact path="/test-drive" element={<TestDrive />} />
          <Route exact path="/training-video" element={<TrainingVideo />} />
          <Route
            exact
            path="/training-video/training-detail/:slug"
            element={<TrainingDetailPage />}
          />
          <Route exact path="/news/news-update" element={<NewsUpdate />} />
          <Route
            exact
            path="/news/news-update/news-detail/:slug"
            element={<NewsDetailPage />}
          />
          <Route path="/dealer/:id" element={<DealerInfo />} />
          <Route path="/*" element={draftPreviewComponent} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/cookies" element={<CookiesPolicy />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/search" element={<SearchResultPage />} />
          <Route
            path="/purchase-support/dealer-search"
            element={<DealerSearchWrapper />}
          />
          <Route path="/news/live-stream" element={<LiveStream />} />
          <Route
            path="/news/live-stream/:slug"
            element={<LiveStreamDetail />}
          />
          <Route
            path="/general-detail-pages/:slug"
            element={<LiveStreamDetail />}
          />
          <Route
            path="/news/events-and-campaigns"
            element={<EventAndCampaign />}
          />
          <Route
            path="/news/events-and-campaigns/:slug"
            element={<EventAndCampaignDetail />}
          />
          <Route path="/customer-service" element={<CustomerService />} />
          <Route
            path="/service-contract-detail/:slug"
            element={<ServiceGuide />}
          />
          <Route path="/finance-and-leasing" element={<FinanceAndLeasing />} />
          <Route path="/truck-model/:slug" element={<CarModel />} />
          <Route
            path="/truck-model-details/:slug"
            element={<CarModelDetail />}
          />
          <Route path="/industry/:slug" element={<Industry />} />
          <Route path="/environmentQuery" element={<EnvQuery />} />
          <Route
            path="/industry-detail-pages/:slug"
            element={<IndustryDetailPage />}
          />
          <Route path="/purchased-truck/:slug" element={<ConnectedTruck />} />
          <Route
            path="/accessories-collec-pages/:slug"
            element={<IndustryDetailPage />}
          />
          <Route
            path="/accessories-detail-pages/:slug"
            element={<PurchasedDetail />}
          />
          <Route
            path="/purchased-truck-detail/:slug"
            element={<PurchasedDetail />}
          />
          <Route path="/connected-detail/:slug" element={<PurchasedDetail />} />
          <Route path="/connected-truck/:slug" element={<ConnectedTruck />} />
          <Route
            path="/finance-leasing-detail/:slug"
            element={<PurchasedDetail />}
          />
          <Route path="/" element={<HomePage />} />
        </Routes>
      </Box>
      <Footer />
    </BrowserRouter>
  );
};

export default Routers;
